const manualStateLocateRequests = {
  stateNameOverrides: {
    ca: 'California - USA North 811',
    id: 'Idaho - Dig Line',
    ny: 'New York 811',
  },

  states: [
    {
      id: 998,
      sort: 0,
      name: 'California - DigAlert / Underground Service Alert of Southern California',
      abbreviation: 'CA-DIGALERT',
    },
    {
      id: 997,
      sort: 0,
      name: 'Idaho - Digsafe of North Idaho 811',
      abbreviation: 'ID-DIGSAFE',
    },
    {
      id: 996,
      sort: 0,
      name: 'Idaho - North Idaho 811',
      abbreviation: 'ID-NORTH',
    },
    {
      id: 995,
      sort: 0,
      name: 'New York - UDig NY',
      abbreviation: 'NY-UDIG',
    },
  ],

  locateRequests: {
    'ca-digalert': {
      locateRequest: [
        {
          id: 998,
          status: 1,
          sort: 0,
          state: {
            id: 998,
            sort: 0,
            name: 'California',
            abbreviation: 'CA-DIGALERT',
            statue: null,
            regulation: null,
            additionalRegulation: null,
          },
          oneCall1: 'https://newtinb.digalert.org/direct/',
          oneCall2: null,
          oneCallTicketEntry1: 'https://newtinb.digalert.org/direct/',
          oneCallTicketEntry2: null,
        },
      ],
      state: {
        id: 998,
        sort: 0,
        name: 'California',
        abbreviation: 'CA-DIGALERT',
        statue: null,
        regulation: null,
        additionalRegulation: null,
      },
    },

    'id-digsafe': {
      locateRequest: [
        {
          id: 997,
          status: 1,
          sort: 0,
          state: {
            id: 997,
            sort: 0,
            name: 'Idaho - Digsafe of North Idaho 811',
            abbreviation: 'ID-DIGSAFE',
            statue: null,
            regulation: null,
            additionalRegulation: null,
          },
          oneCall1: 'https://digsafenorthidaho811.com/',
          oneCall2: null,
          oneCallTicketEntry1: 'https://digsafenorthidaho811.com/ticketing-hub/',
          oneCallTicketEntry2: null,
        },
      ],
      state: {
        id: 997,
        sort: 0,
        name: 'Idaho - Digsafe of North Idaho 811',
        abbreviation: 'ID-DIGSAFE',
        statue: null,
        regulation: null,
        additionalRegulation: null,
      },
    },

    'id-north': {
      locateRequest: [
        {
          id: 996,
          status: 1,
          sort: 0,
          state: {
            id: 996,
            sort: 0,
            name: 'Idaho - North Idaho 811',
            abbreviation: 'ID-NORTH',
            statue: null,
            regulation: null,
            additionalRegulation: null,
          },
          oneCall1: 'https://www.nid811.com/',
          oneCall2: null,
          oneCallTicketEntry1: 'https://onecall.nid811.com/nid-b4-en/Account/Login',
          oneCallTicketEntry2: null,
        },
      ],
      state: {
        id: 996,
        sort: 0,
        name: 'Idaho - North Idaho 811',
        abbreviation: 'ID-NORTH',
        statue: null,
        regulation: null,
        additionalRegulation: null,
      },
    },

    'ny-udig': {
      locateRequest: [
        {
          id: 995,
          status: 1,
          sort: 0,
          state: {
            id: 995,
            sort: 0,
            name: 'New York - UDig NY',
            abbreviation: 'NY-UDIG',
            statue: null,
            regulation: null,
            additionalRegulation: null,
          },
          oneCall1: 'https://udigny.org/',
          oneCall2: null,
          oneCallTicketEntry1: 'https://udigny.org/',
          oneCallTicketEntry2: null,
        },
      ],
      state: {
        id: 995,
        sort: 0,
        name: 'New York - UDig NY',
        abbreviation: 'NY-UDIG',
        statue: null,
        regulation: null,
        additionalRegulation: null,
      },
    },
  },
};

export default manualStateLocateRequests;


// WEBPACK FOOTER //
// ./src/components/common/stateCallTicketDropdown/manualStateLocateRequests.js